<div class="position-fixed top-0 end-0 p-3"
     style="z-index: 1200;"
     aria-live="polite"
     aria-atomic="true">
  @for (t of toasts$ | async; track t.id) {
  <ngb-toast [ngClass]="[t.options.classname, 'mb-2']"
             [autohide]="t.options.autohide"
             [delay]="t.options.delay"
             (hidden)="remove(t.id)">
    {{ t.text }}
  </ngb-toast>
  }
</div>